import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { NavbarIconButtonWithLabel } from '../NavbarIconButtonWithLabel';
import { UploadIcon } from '../icons/UploadIcon';
export const ScansNavButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const active = location.pathname === '/scans';

  return (
    <NavbarIconButtonWithLabel
      label={t('Scans')}
      active={active}
      onClick={() => {
        if (location.pathname !== '/scans') {
          navigate('/scans');
        }
      }}
    >
      <UploadIcon />
    </NavbarIconButtonWithLabel>
  );
};
